import React, { useState, useCallback } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import apiCoreAdapter from '../../hooks/apiCoreAdapter';
import { toastUtils } from '../../hooks/useToast';
import { Button } from '@/components/ui/button';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';
import { Tooltip, TooltipTrigger, TooltipContent } from '@/components/ui/tooltip';

import { activityTracker } from "../../utils/activityTracker";
export const GoogleMeetButton: React.FC = () => {
  const { user } = useAuth();
  const [openingMeet, setOpeningMeet] = useState(false);
  const [showMeetReminder, setShowMeetReminder] = useState(false);

  const handleOpenGoogleMeet = useCallback(async () => {
    if (openingMeet) return;
    try {
      setOpeningMeet(true);
      const resp = await apiCoreAdapter.getExternalToolUrl('google meet');
      const url = resp?.content;
      if (url && typeof url === 'string') {
        const meetUrl = user?.email ? `${url}?authuser=${user.email}` : url;
        window.open(meetUrl, '_blank', 'noopener,noreferrer');
        activityTracker.trackAction('meet_opened');
      } else {
        try { toastUtils.error('No se encontró el enlace de Google Meet'); } catch { /* noop */ }
      }
    } catch (_e) {
      try { toastUtils.error('No se pudo obtener el enlace de Google Meet'); } catch { /* noop */ }
    } finally {
      setOpeningMeet(false);
    }
  }, [openingMeet, user?.email]);

  return (
    <>
      <Tooltip>
        <TooltipTrigger asChild>
          <Button
            variant="default"
            size="default"
            data-testid="enter-google-meet-button"
            onClick={() => setShowMeetReminder(true)}
            disabled={openingMeet}
            className="gap-2 whitespace-nowrap cursor-pointer h-12 px-6 text-base font-semibold bg-[#2d2049] border-2 border-white ring-2 ring-[#2d2049]/50 ring-offset-0 text-white shadow-md hover:bg-[#241a3d]"
          >
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <polygon points="23 7 16 12 23 17 23 7" />
              <rect x="1" y="5" width="15" height="14" rx="2" ry="2" />
            </svg>
            {openingMeet ? 'Cargando...' : 'Ingresar a tus sesiones'}
          </Button>
        </TooltipTrigger>
        <TooltipContent>
          Desde aquí podés ingresar a todas las sesiones con tus pacientes: no cambia según el día ni el paciente.
        </TooltipContent>
      </Tooltip>

      <Dialog open={showMeetReminder} onOpenChange={setShowMeetReminder}>
        <DialogContent className="sm:max-w-md">
          <div className="px-6 pt-5 pb-6">
            <DialogHeader>
              <DialogTitle>Antes de ingresar</DialogTitle>
            </DialogHeader>
            <div className="mt-1 mb-4">
              <div className="p-3 bg-yellow-50 border border-yellow-200 rounded-lg">
                <p className="text-sm text-yellow-800">
                  <strong>Recordatorio:</strong> asegurate de estar logueada en Google Meet con tu cuenta de <strong>@psimammoliti</strong> para evitar errores al ingresar.
                </p>
              </div>
            </div>
            <div className="flex justify-end gap-2">
              <Button variant="outline" onClick={() => setShowMeetReminder(false)}>
                Volver
              </Button>
              <Button
                disabled={openingMeet}
                onClick={() => { setShowMeetReminder(false); handleOpenGoogleMeet(); }}
                className="bg-[#6D57BC] text-white hover:bg-[#5a47a8]"
              >
                {openingMeet ? 'Cargando...' : 'Ingresar al Meet'}
              </Button>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default GoogleMeetButton;
